import {Controller} from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import {InputLabel, MenuItem, Select} from "@mui/material";
import React from "react";
import i18next from "i18next";

import type {Control, FieldValues, Path, RegisterOptions} from "react-hook-form";
import type { TranslationKey } from "@shared/i18n/translationKey";

export interface SelectControllerProps<T extends FieldValues = FieldValues> {
    control: Control<T>;
    name: Path<T>;
    label: string;
    rules?: RegisterOptions<T>;
    defaultValue?: unknown;
    listValue?: string[];
    /**
     * OJO: hoy este prop NO se reenvia. El componente solo pasa el `field` de
     * react-hook-form al Select, asi que el handler que le mande quien llama se descarta en
     * silencio. Seis call sites lo pasan — entre ellos el selector de año de prefacturas,
     * que deberia resetear el mes al cambiar de año y no lo hace. Se declara para que el
     * tipo refleje lo que se pasa, y queda anotado para un fix aparte: reenviarlo cambia
     * comportamiento en seis pantallas a la vez.
     */
    onChange?: (event: { target: { value: string } }) => void;
}

const SelectController = <T extends FieldValues = FieldValues>({control, name, label, rules, defaultValue, listValue}: SelectControllerProps<T>) => {

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue as never}
            rules={rules as never}
            render={({field}) => (
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">{label}</InputLabel>
                    <Select
                        {...field}
                        label={label}
                        defaultValue={defaultValue as never}
                    >
                        {listValue?.map((value, index) => (
                            <MenuItem value={value} key={index}>
                                {/* Las opciones pueden ser claves i18n o datos crudos (anios, nombres de mes
                                    ya traducidos); si no hay clave, i18next devuelve el valor tal cual. */}
                                {i18next.t(value as TranslationKey)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        />
    )
}

export default SelectController;
